import * as React from 'react';
import { useLocation } from 'react-router-dom';

export const HeroSnackbarCtx = React.createContext({
  isOpen: false,
  setIsOpen: () => {},
  color: 'success',
  title: null,
  message: '',
  showHeroSnackbar: ({ message, color, title, autoClose }) => {},
  closeHeroSnackbar: () => {},
  autoClose: true,
});

export function HeroSnackbarProvider({ children }) {
  const location = useLocation();
  const locPathName = location.pathname;
  const [isOpen, setIsOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [color, setColor] = React.useState('success');
  const [title, setTitle] = React.useState('');
  const [autoClose, setAutoClose] = React.useState(true);
  const [currentPageUrl, setCurrentPageUrl] = React.useState(location);
  
  const showHeroSnackbar = ({
    message,
    color = 'success',
    title = null,
    autoClose = true,
  }) => {
    setCurrentPageUrl(locPathName);
    setAutoClose(autoClose);
    setMessage(message);
    setTitle(title);
    setColor(color);
    setIsOpen(true);
  };

  const closeHeroSnackbar = () => {
    setIsOpen(false);
    setMessage('');
  };


  React.useEffect(() => {
    let timer;
    if (isOpen && autoClose) {
      timer = setTimeout(() => {
        setIsOpen(false);
      }, 6500);
    }

    return () => clearTimeout(timer);
  }, [isOpen, autoClose]);

  React.useEffect(() => {
    if (currentPageUrl !== locPathName && isOpen) setIsOpen(false);
  }, [locPathName, isOpen, currentPageUrl]);

  return (
    <HeroSnackbarCtx.Provider
      value={{
        isOpen,
        message,
        color,
        showHeroSnackbar,
        setIsOpen,
        closeHeroSnackbar,
        title,
        autoClose,
      }}
    >
      {children}
    </HeroSnackbarCtx.Provider>
  );
}
